import type {
  ProcurementRole,
  ProcurementStage,
  PurchaseRequest,
} from "./models";

export type ProcurementWorkflowState = {
  stage: ProcurementStage;
  responsibleRole: ProcurementRole | null;
  terminal: boolean;
};

export function procurementWorkflowStateOf(
  request: PurchaseRequest,
): ProcurementWorkflowState {
  if (request.status === "Onaylandı") {
    return { stage: "Tamamlandı", responsibleRole: null, terminal: true };
  }
  if (request.status === "Reddedildi") {
    return {
      stage: "Reddedildi",
      responsibleRole: "SATIN_ALMA_MUDURU",
      terminal: false,
    };
  }
  if (request.pendingApprovalRole === "GENEL_MUDUR") {
    return {
      stage: "Genel Müdür Onayında",
      responsibleRole: "GENEL_MUDUR",
      terminal: false,
    };
  }
  if (request.pendingApprovalRole === "SATIN_ALMA_MUDURU") {
    return {
      stage: "Müdür Onayında",
      responsibleRole: "SATIN_ALMA_MUDURU",
      terminal: false,
    };
  }
  if (request.status === "Satın Almaya iletildi" && request.offers === 0) {
    return {
      stage: "Teklif Bekliyor",
      responsibleRole: "SATIN_ALMA",
      terminal: false,
    };
  }
  return {
    stage: "Uzman Hazırlıyor",
    responsibleRole: "SATIN_ALMA",
    terminal: false,
  };
}

export function procurementStageOf(request: PurchaseRequest) {
  return procurementWorkflowStateOf(request).stage;
}
